
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    CLOUDLOGINPAGE_UPLOAD_SEARCH_IMAGE_REQUEST,
    CLOUDLOGINPAGE_UPLOAD_IMAGE_REQUEST,
} from 'Redux/actionTypes';

import { searchImageResult, uploadImageResult } from 'Redux/actions';

import { endpoints } from 'Core/defaultValues';
import { clientMutation, clientQuery } from 'Core/data/GraphQLApi';
import { uploadFile } from 'Core/data/FileUpload';

function* searchImages({ payload }) {
    try {
        let QUERY = `
        query searchImages ($dealerId: Int!) {
            result: searchImages (dealerId: $dealerId){
                key
                url
            }
        }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                dealerId: 16
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(searchImageResult(data.result))
        }

    } catch (exc) {
        yield put(searchImageResult([]))
        ExceptionManager(
            exc,
            "Modules/loginPage/main/.components/uploadImage/redux/saga",
            "searchImages",
        )
    }
}

function* uploadImage({ payload }) {
    const { file, name, type } = payload
    try {
        let QUERY = `
            mutation uploadImage ($fileKey: String!, $fileType: String!, $dealerId: Int) {
                result: uploadImage (fileKey: $fileKey, fileType: $fileType, dealerId: $dealerId) {
                    url
                    fileKey
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                fileKey: name,
                fileType: type,
                dealerId: 16
            },
            endpoints.GRAPHQL_GENERAL,
        );
        let newUrl = null
        if (data.result.url) {
            newUrl = data.result.url.split("?")
            yield uploadFile(data.result.url, file);
        }
        yield put(uploadImageResult({ upload: true, url: newUrl ? newUrl[0] : null }))


    } catch (exc) {
        yield put(uploadImageResult({ upload: false }))
        ExceptionManager(
            exc,
            "Modules/loginPage/main/.components/uploadImage/redux/saga",
            "uploadImage",
        )
    }
}

function* watchMethods() {
    yield takeEvery(CLOUDLOGINPAGE_UPLOAD_SEARCH_IMAGE_REQUEST, searchImages);
    yield takeEvery(CLOUDLOGINPAGE_UPLOAD_IMAGE_REQUEST, uploadImage)
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}